"use strict";

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paginateAll = exports.getCustomerAccessToken = exports.logGraphErrorsArray = exports.ebooksOrderQuery = exports.customerAccessTokenQuery = exports.storefrontAccessToken = exports.graphQlUrl = void 0;

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("regenerator-runtime/runtime");

require("core-js/modules/es6.array.for-each");

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var graphQlUrl = '/api/2022-04/graphql.json';
exports.graphQlUrl = graphQlUrl;
var storefrontAccessToken = '2a217033303b1eb7d3e30ba786c79c59';
exports.storefrontAccessToken = storefrontAccessToken;

var customerAccessTokenQuery = function customerAccessTokenQuery() {
  return "\nmutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {\n  customerAccessTokenCreate(input: $input) {\n    customerUserErrors {\n      code\n      field\n      message\n    }\n    customerAccessToken {\n      accessToken\n      expiresAt\n    }\n  }\n}";
};

exports.customerAccessTokenQuery = customerAccessTokenQuery;
var ebooksOrderQuery = "\n  query customerOrders($count: Int!, $cursor: String, $customerAccessToken: String!) {\n    customer(customerAccessToken: $customerAccessToken) {\n      orders(first: $count, after: $cursor, sortKey: PROCESSED_AT, reverse: true) {\n        pageInfo {\n          hasNextPage\n          hasPreviousPage\n        }\n        edges {\n          cursor\n          node {\n            customerUrl\n          }\n        }\n      }\n    }\n  }";
exports.ebooksOrderQuery = ebooksOrderQuery;

var logGraphErrorsArray = function logGraphErrorsArray(errors) {
  errors.forEach(function (error) {
    return window.console.error('GraphQl Error: ', error);
  });
};
/**
 * Creates a customerAccessToken
 * and stores the token in LocalStorage
 *
 */


exports.logGraphErrorsArray = logGraphErrorsArray;

var getCustomerAccessToken = function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(email, password) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Remove the customer access token from local storage
            if (window.localStorage.getItem('mb-customer-access-token') !== null) {
              window.localStorage.removeItem('mb-customer-access-token');
            } // Get the customer access token


            _context.next = 3;
            return (0, _axios["default"])({
              url: graphQlUrl,
              method: 'post',
              data: {
                query: customerAccessTokenQuery(),
                variables: {
                  input: {
                    email: email,
                    password: password
                  }
                }
              },
              headers: {
                'X-Shopify-Storefront-Access-Token': storefrontAccessToken
              }
            }).then(function (response) {
              if (response.data.errors) {
                window.console.log('ERROR RETREIVING CUSTOMER ACCESS TOKEN', response.data.errors);
                logGraphErrorsArray(response.data.errors);
                return false;
              }

              window.localStorage.setItem('mb-customer-access-token', response.data.data.customerAccessTokenCreate.customerAccessToken.accessToken);
              window.localStorage.setItem(response.data.data.customerAccessTokenCreate.customerAccessToken.accessToken, email);
              return true;
            })["catch"](function (error) {
              window.console.error('ACCESS TOKEN ERROR', error);
              return false;
            });

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getCustomerAccessToken(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.getCustomerAccessToken = getCustomerAccessToken;

function findEdge(edges, data) {
  edges.forEach(function (edge) {
    // eslint-disable-next-line no-param-reassign
    data = data[edge];
  });
  return data;
}

var page = 1;
/**
 * Paginate All
 * Paginates through all pages of a given graph using a recurive function.
 */

var paginateAll = function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(query, vars, ret, setProgress) {
    var response, loopData;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _axios["default"])({
              url: graphQlUrl,
              method: 'post',
              data: {
                query: query,
                variables: vars
              },
              headers: {
                'X-Shopify-Storefront-Access-Token': storefrontAccessToken
              }
            })["catch"](function (error) {
              window.console.error(error);
              return 'failed';
            });

          case 2:
            response = _context2.sent;

            if (!(response === 'failed')) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", 'failed');

          case 5:
            if (!(typeof response.data.errors !== 'undefined')) {
              _context2.next = 8;
              break;
            }

            logGraphErrorsArray(response.data.errors);
            return _context2.abrupt("return", 'failed');

          case 8:
            // Concat the chuncks of data
            loopData = findEdge(vars.edges, response.data.data);
            ret.data = ret.data.concat(loopData.edges); // Determine if there is more data to retrieve and retrieve if necessary

            if (!(loopData.pageInfo.hasNextPage === true)) {
              _context2.next = 17;
              break;
            }

            vars.cursor = loopData.edges.slice(-1).pop().cursor;
            page++;
            setProgress(1, page);
            _context2.next = 16;
            return paginateAll(query, vars, ret, setProgress);

          case 16:
            ret.data = _context2.sent;

          case 17:
            if (!(ret.data === 'failed')) {
              _context2.next = 19;
              break;
            }

            return _context2.abrupt("return", 'failed');

          case 19:
            return _context2.abrupt("return", ret.data);

          case 20:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function paginateAll(_x3, _x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

exports.paginateAll = paginateAll;